import { useTypedSelector } from '../../hooks/useTypedSelector'
import { uiVersion } from '../../versions'
import styles from './index.module.scss'
import { selectProducts } from '../../store/selectors/productsSelectors'
import { ProductStatus } from '../../entity/Product'
import { useEffect } from 'react'
import { fetchInfo } from '../../store/actions/infoActions'
import { useAppDispatch } from '../../hooks/useAppDispatch'
import GreenBarsImg from '../../assets/images/greenBars.png'
import { FormattedMessage } from 'react-intl'

export const MainInfo = () => {
    const dispatch = useAppDispatch()
    const { info } = useTypedSelector((state: any) => state.info)
    const { app_version: appVersion } = info
    const products = useTypedSelector(selectProducts)

    const activeProductsCount = products.filter(
        (product) => product.status === ProductStatus.ACTIVE
    ).length

    const inactiveProductsCount = products.filter(
        (product) => product.status === ProductStatus.INACTIVE
    ).length

    const idleProductsCount = products.filter(
        (product) => product.status === ProductStatus.IDLE
    ).length

    useEffect(() => {
        dispatch(fetchInfo())
    }, [dispatch])

    return (
        <div className={`${styles.contentBox} d-flex flex-1`}>
            <div
                className={`p-4 flex-1 flex-column`}
                style={{
                    backgroundImage: 'url(' + GreenBarsImg + ')',
                    backgroundSize: '400px 500px',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'right',
                }}
            >
                <h1 className={`${styles.mainTitle} mb-3`}>
                    <FormattedMessage id="homePage.welcome" />
                </h1>
                <div>
                    <FormattedMessage id="homePage.tbUI" />
                    <span>v{uiVersion}</span>
                </div>
                <div className="mb-3">
                    <FormattedMessage id="homePage.tbApp" />
                    <span>v{appVersion}</span>
                </div>
                <div>
                    <FormattedMessage id="homePage.active" />
                    <span className="p-active mr-2" />
                    <span className="fw-bold"> {activeProductsCount}</span>
                </div>
                <div>
                    <FormattedMessage id="homePage.inactive" />
                    <span className="p-inactive mr-2" />
                    <span className="fw-bold"> {inactiveProductsCount}</span>
                </div>
                <div>
                    <FormattedMessage id="homePage.onStandby" />
                    <span className="p-idle mr-2" />
                    <span className="fw-bold"> {idleProductsCount}</span>
                </div>
            </div>
        </div>
    )
}
